import useMutation from "src/hooks/useMutation";

function useOrderRemove(id) {
  return useMutation({
    path: `/api/v1/orders/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: [`/api/v1/orders`, `/api/v1/orders/count`],
      shouldRevalidate: true,
    },
  });
}

export default useOrderRemove;
